import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FHETable } from 'data/components';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { Toastr } from 'data/common';
import { getAllProjects } from '../../data/Projects/actions';
import tools from "../../../../data/common/tools";

class CommercialAgent extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        getAllProjects: PropTypes.func.isRequired,
        projects: PropTypes.object.isRequired,
        commercialAgents: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshProjects();
    }

    refreshProjects = () => {
        const { getAllProjects } = this.props;
        this.setState({ loading: true });
        return getAllProjects()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `project/detail/${rowData.id}` });
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`${history.environment}.project.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshProjects
                }
            ]
        };
        if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('projectDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`$general.showDetail`)
            });
        }
        return actions;
    });

    renderData = memoizeOne((projects, commercialAgents) => {
        let results = [];

        projects.map((project, projectId) => {
            const CA = commercialAgents.get(project.get('commercialAgentId').toString());

            results.push({
                id: parseInt(projectId),
                label: project.get('label'),
                email: project.get('email'),
                residents: project.get('residents'),
                surface: parseInt(project.get('surface')),
                price: parseInt(project.get('price')),
                priceFHE: parseInt(project.get('priceFHE')),
                lastUpdate: project.get('lastUpdate'),
                commercialEmail: CA.get('email')
            });
        });

        return results;
    });
    renderColumns = memoizeOne(profile => {
        const { history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('projectDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`$general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.commercialEmail'),
                name: 'commercialEmail'
            },
            {
                title: Translator.translate('general.table.column.surface'),
                name: 'surface',
                render: (row, data, value) => {
                    if (!value) return null;
                    return `${value}m²`;
                }
            },
            {
                title: Translator.translate('general.table.column.price'),
                name: 'price',
                render: (row, data, value) => {
                    if (!value) return null;
                    return `${value} €`;
                }
            },
            {
                title: Translator.translate('general.table.column.priceFHE'),
                name: 'priceFHE',
                render: (row, data, value) => {
                    if (!value) return null;
                    return `${value} €`;
                }
            },
            {
                title: Translator.translate('general.table.column.lastUpdate'),
                name: 'lastUpdate',
                customSort: tools.sortDate
            }
        ];
    });

    render() {
        const { loading } = this.state;
        const { projects, commercialAgents, history, profile } = this.props;

        return (
            <FHETable
                idTable="projectList"
                columns={this.renderColumns(profile)}
                data={this.renderData(projects, commercialAgents)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`${history.environment}.project.table.title`)}
                emptyDataSourceMessage={Translator.translate(`${history.environment}.project.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    return {
        profile: state.data.user,
        commercialAgents: state.environments[history.environment].data.CommercialAgents.get('list'),
        projects: state.environments[history.environment].data.Projects.get('list'),
        initialized: state.environments[history.environment].data.Projects.get('initialized')
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getAllProjects }, dispatch)
    )(CommercialAgent)
);



// WEBPACK FOOTER //
// ./environments/simulationenr/scenes/Project/index.js